import { Container, Row, Col } from '@paypalcorp/pp-react'
import { VideoRow } from '../../components/video-lib/sections/VideoRow'
import { navigate } from 'gatsby'
import CircularIconsRow from '../../components/video-lib/sections/CircularIconsRow'
import '../../components/video-lib/css/index.css'
import { groupBy } from 'lodash'
import React, { useMemo } from 'react'
import VideoLayout from '../../components/video-lib/components/VideoLayout'
import videos from '../../components/video-lib/data/videos.json'
import useParams from '../../hooks/useParams'

function Home() {
  const { q: searchText } = useParams()

  const groupedByProductId = useMemo(
    () =>
      groupBy(videos, (item) =>
        (item['video-Product-id'] || 'others')
          .toLowerCase()
          .replace(/\s+/g, ''),
      ),
    [videos],
  )

  return (
    <>
      <Container>
        <Row style={{ padding: '2.5rem 0' }}>
          <Col>
            <h1 className="homepageTitle" data-testid="header-title">
              Video Library
            </h1>
          </Col>
          <Col
            className="video-search"
            style={{
              display: 'flex',
              justifyContent: 'end',
              paddingRight: '5rem',
            }}
          >
            <input
              data-testid="search-input"
              value={searchText}
              className="search"
              placeholder="Search by keyword"
              name="search"
              onKeyDown={(e: any) => {
                if (e.key === 'Enter') {
                  navigate(`/video/collection?q=${e.currentTarget.value}`)
                }
              }}
            />
          </Col>
        </Row>
      </Container>
      <VideoRow
        videos={videos.slice(0, 4)}
        title="Recommended for you"
        viewAllUrl="/video/collection?filter=all"
        altBackground
        dataTestid="recommended"
      />
      <CircularIconsRow
        groupedVideos={groupedByProductId}
        title="Integrate with your ecommerce platform"
      />
      {groupedByProductId['paypal-basics'] && (
        <VideoRow
          videosCount={
            groupedByProductId['paypal-basics'] &&
            groupedByProductId['paypal-basics']?.length
          }
          videos={
            groupedByProductId['paypal-basics']
              ? groupedByProductId['paypal-basics'].slice(0, 4)
              : []
          }
          title="PayPal Basics"
          viewAllUrl="/video/collection?filter=paypal-basics"
          dataTestid="paypal-basics"
        />
      )}

      {groupedByProductId['paypal-checkout'] && (
        <VideoRow
          videosCount={
            groupedByProductId['paypal-checkout'] &&
            groupedByProductId['paypal-checkout']?.length
          }
          videos={
            groupedByProductId['paypal-checkout']
              ? groupedByProductId['paypal-checkout'].slice(0, 4)
              : []
          }
          title="PayPal Checkout"
          viewAllUrl="/video/collection?filter=paypal-checkout"
          dataTestid="paypal-checkout"
        />
      )}

      {groupedByProductId['paypal-subscriptions'] && (
        <VideoRow
          videosCount={
            groupedByProductId['paypal-subscriptions'] &&
            groupedByProductId['paypal-subscriptions']?.length
          }
          videos={
            groupedByProductId['paypal-subscriptions']
              ? groupedByProductId['paypal-subscriptions'].slice(0, 4)
              : []
          }
          title="Subscriptions"
          viewAllUrl="/video/collection?filter=paypal-subscriptions"
          dataTestid="paypal-subscriptions"
        />
      )}
    </>
  )
}

export default function HomeWrapper() {
  return (
    <VideoLayout>
      <Home />
    </VideoLayout>
  )
}
